import CargoCompanyAddressListResponse, {
  CargoCompanyAddressListResponseItem,
  CargoCompanyAddressListResponseItemCargoAddressType,
} from "../../../../api/raily/cargo-company/address/list/cargo-company-address-list.response";
import CargoAddressType from "../../../../types/cargo-address-type";
import CargoCompanyAddressList, {
  CargoCompanyAddressListItem,
} from "./cargo-company-address-list";

const createDataItemCargoAddressType = (
  cargoAddressType: CargoCompanyAddressListResponseItemCargoAddressType,
): CargoAddressType => {
  switch (cargoAddressType) {
    case CargoCompanyAddressListResponseItemCargoAddressType.HOTEL:
      return CargoAddressType.HOTEL;
    case CargoCompanyAddressListResponseItemCargoAddressType.STATION:
      return CargoAddressType.STATION;
    case CargoCompanyAddressListResponseItemCargoAddressType.MEETING_POINT:
      return CargoAddressType.MEETING_POINT;
  }
};

const createDataItem = (
  responseItem: CargoCompanyAddressListResponseItem,
): CargoCompanyAddressListItem => {
  return {
    cargoAddressType: createDataItemCargoAddressType(
      responseItem.cargoAddressType,
    ),
    id: responseItem.id,
    displayName: responseItem.displayName,
    lat: responseItem.lat,
    lon: responseItem.lon,
    apartment: responseItem.apartment,
    houseNumber: responseItem.houseNo,
    street: responseItem.street,
    town: responseItem.town,
    zipCode: responseItem.zipCode,
    country: responseItem.country,
    description: responseItem.description,
  };
};

const createData = (
  responseData: CargoCompanyAddressListResponseItem[],
): CargoCompanyAddressListItem[] => {
  return responseData.map(createDataItem);
};

const create = (
  response: CargoCompanyAddressListResponse,
): CargoCompanyAddressList => {
  return createData(response.data);
};

const cargoCompanyAddressListFactory = {
  create,
};

export default cargoCompanyAddressListFactory;
